(function () {
    "use strict";

    angular.module("sempraWebapp").controller("RolloverProgramsController", RolloverProgramsController);

    /** @ngInject */
    function RolloverProgramsController(
        $scope,
        $state,
        $stateParams,
        $timeout,
        $translate,
        $mdDialog,
        dashboardKarcherActions,
        dialogsService,
        layoutActions,
        userActions
    ) {
        var vm = this;

        vm.siteId = $stateParams.siteId;
        vm.siteName = '';
        vm.programs = [];
        vm.options = [];
        vm.selectedProgram = null;
        vm.isLoading = true;
        vm.isLoadingOptions = false;
        
        // New fields for voucher configuration
        vm.salesTypes = [];
        vm.selectedSalesType = null;
        vm.numberOfWashes = 1;
        vm.minDate = new Date(); // Minimum date for Valid From (today)
        vm.validFrom = new Date();
        vm.validityDays = 90; // Default, will be loaded from company
        vm.validTo = new Date(new Date().setDate(new Date().getDate() + 90));
        vm.showHappyHour = true;
        vm.happyHourEnabled = false;
        vm.happyHour1Start = null;
        vm.happyHour1End = null;
        vm.happyHour2Start = null;
        vm.happyHour2End = null;
        vm.happyHour1StartError = null;
        vm.happyHour1EndError = null;
        vm.happyHour2StartError = null;
        vm.happyHour2EndError = null;
        
        vm.onProgramSelect = onProgramSelect;
        vm.selectProgram = selectProgram;
        vm.toggleOption = toggleOption;
        vm.getSelectedOptions = getSelectedOptions;
        vm.getSelectedOptionsNames = getSelectedOptionsNames;
        vm.getTotalPrice = getTotalPrice;
        vm.getOptionsTotal = getOptionsTotal;
        vm.getProgramPrice = getProgramPrice;
        vm.createAndPrintVoucher = createAndPrintVoucher;
        vm.goBack = goBack;
        vm.goToSalesTypes = goToSalesTypes;
        vm.cancelSelection = cancelSelection;
        vm.incrementWashes = incrementWashes;
        vm.decrementWashes = decrementWashes;
        vm.canSelectMoreOptions = canSelectMoreOptions;
        vm.getListPrice = getListPrice;
        vm.maxOptionsSelected = 6;
        vm.isCreating = false;
        vm.voucherSearchCode = '';
        vm.isSearching = false;
        vm.voucherSearchError = null;
        vm.searchVoucher = searchVoucher;
        vm.isValidVoucherCode = isValidVoucherCode;
        vm.vouchersForPrint = [];
        vm.issuedDateLabel = $translate.instant('ISSUED_DATE');
        vm.expiryDateLabel = $translate.instant('EXPIRY_DATE');
        vm.remainingWashesLabel = $translate.instant('ROLLOVER_REMAINING_WASHES');
        vm.onValidFromChange = onValidFromChange;
        vm.onValidityDaysChange = onValidityDaysChange;
        vm.onValidToChange = onValidToChange;
        vm.validateHappyHour1 = validateHappyHour1;
        vm.validateHappyHour2 = validateHappyHour2;
        vm.onSalesTypeChange = onSalesTypeChange;

        init();

        function init() {
            $scope.$on("$destroy", onDestroyHandler);
            loadPrograms();
            loadCompanyExpirationDays();
            loadSalesTypes();
        }

        function loadSalesTypes() {
            dashboardKarcherActions.getRolloverSalesTypes().then(
                function (response) {
                    vm.salesTypes = response || [];
                    if (vm.salesTypes.length > 0) {
                        vm.selectedSalesType = vm.salesTypes[0];
                        onSalesTypeChange();
                    }
                },
                function () {
                    vm.salesTypes = [];
                }
            );
        }

        function loadCompanyExpirationDays() {
            userActions.getCompanyDetails().then(function(companyData) {
                if (companyData && companyData.rolloverVoucherExpirationDays) {
                    vm.validityDays = companyData.rolloverVoucherExpirationDays;
                    // Update validTo based on loaded days
                    var newValidTo = new Date(vm.validFrom);
                    newValidTo.setDate(newValidTo.getDate() + vm.validityDays);
                    vm.validTo = newValidTo;
                }
            });
        }

        function onDestroyHandler() {
            vm.programs = [];
            vm.options = [];
            vm.selectedProgram = null;
            vm.selectedSalesType = null;
        }

        function loadPrograms() {
            vm.isLoading = true;
            layoutActions.showLoader();
            
            // Load programs for the site (from all rollover devices)
            dashboardKarcherActions.getRolloverProgramsBySite(vm.siteId).then(
                function (response) {
                    vm.programs = response || [];
                    vm.isLoading = false;
                    layoutActions.hideLoader();
                },
                function () {
                    vm.programs = [];
                    vm.isLoading = false;
                    layoutActions.hideLoader();
                }
            );
        }

        function selectProgram(program) {
            vm.selectedProgram = program;
            onProgramSelect();
        }

        function onProgramSelect() {
            if (!vm.selectedProgram) {
                vm.options = [];
                return;
            }
            
            vm.options = [];
            vm.isLoadingOptions = true;
            
            // Load options for the selected program using deviceId from program
            dashboardKarcherActions.getRolloverProgramOptions(vm.selectedProgram.deviceId, vm.selectedProgram.id).then(
                function (response) {
                    vm.options = (response || []).map(function(option) {
                        option.selected = false;
                        return option;
                    });
                    vm.isLoadingOptions = false;
                },
                function () {
                    vm.options = [];
                    vm.isLoadingOptions = false;
                }
            );
        }

        function toggleOption(option) {
            // If trying to select and already at max, don't allow
            if (!option.selected && !canSelectMoreOptions()) {
                return;
            }
            option.selected = !option.selected;
        }

        function canSelectMoreOptions() {
            return getSelectedOptions().length < vm.maxOptionsSelected;
        }

        function getSelectedOptions() {
            return vm.options.filter(function(option) {
                return option.selected;
            });
        }

        function getSelectedOptionsNames() {
            return getSelectedOptions().map(function(option) {
                return option.name;
            }).join(', ');
        }

        function getTotalPrice() {
            if (vm.selectedSalesType && vm.selectedSalesType.isZeroPrice) {
                return 0;
            }
            
            var total = 0;
            var useSpecialOfferPrice = vm.selectedSalesType && vm.selectedSalesType.isSpecialOfferPrices;
            
            if (vm.selectedProgram) {
                if (useSpecialOfferPrice && vm.selectedProgram.soPrice) {
                    total += vm.selectedProgram.soPrice.amount;
                } else if (vm.selectedProgram.price) {
                    total += vm.selectedProgram.price.amount;
                }
            }
            
            total += getOptionsTotal();
            
            return total;
        }

        function getOptionsTotal() {
            if (vm.selectedSalesType && vm.selectedSalesType.isZeroPrice) {
                return 0;
            }
            var total = 0;
            var useSpecialOfferPrice = vm.selectedSalesType && vm.selectedSalesType.isSpecialOfferPrices;
            getSelectedOptions().forEach(function(option) {
                if (useSpecialOfferPrice && option.soPrice) {
                    total += option.soPrice.amount;
                } else if (option.price) {
                    total += option.price.amount;
                }
            });
            return total;
        }

        function createAndPrintVoucher() {
            if (!vm.selectedProgram) {
                return;
            }

            // Validate Happy Hour times
            if (vm.happyHourEnabled) {
                if (!validateHappyHour1() || !validateHappyHour2()) {
                    return;
                }
            }
            
            vm.isCreating = true;
            
            var selectedOptions = getSelectedOptions();
            var voucherData = {
                siteId: vm.siteId,
                deviceId: vm.selectedProgram.deviceId,
                programId: vm.selectedProgram.id,
                programName: vm.selectedProgram.name,
                optionIds: selectedOptions.map(function(opt) { return opt.id; }),
                salesTypeId: vm.selectedSalesType ? vm.selectedSalesType.id : null,
                numberOfWashes: vm.numberOfWashes,
                validFrom: vm.validFrom,
                validTo: vm.validTo,
                happyHourEnabled: vm.happyHourEnabled,
                happyHour1Start: vm.happyHour1Start,
                happyHour1End: vm.happyHour1End,
                happyHour2Start: vm.happyHour2Start,
                happyHour2End: vm.happyHour2End,
                totalPrice: getTotalPrice()
            };
            
            dashboardKarcherActions.createRolloverVoucher(voucherData).then(
                function (response) {
                    vm.isCreating = false;
                    vm.vouchersForPrint = [response];
                    print();
                },
                function (error) {
                    vm.isCreating = false;
                    console.error('Error creating voucher:', error);
                }
            );
        }

        function print() {
            $timeout(function () {
                window.print();
                // Show confirmation dialog after print
                showPrintConfirmDialog(vm.vouchersForPrint[0].voucherCode);
            }, 100);
        }

        function showPrintConfirmDialog(voucherCode) {
            $mdDialog.show({
                controller: PrintConfirmDialogController,
                controllerAs: 'dialog',
                templateUrl: 'app/rollover/rolloverPrintConfirmDialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: false,
                locals: {
                    voucherCode: voucherCode,
                    onConfirm: function() {
                        cancelSelection();
                    }
                }
            });
        }

        /** @ngInject */
        function PrintConfirmDialogController($mdDialog, voucherCode, onConfirm) {
            var dialog = this;
            dialog.voucherCode = voucherCode;

            dialog.confirm = function() {
                $mdDialog.hide();
                onConfirm();
            };
        }

        function goBack() {
            $state.go('app.rollover', { showList: true });
        }

        function isValidVoucherCode() {
            var code = (vm.voucherSearchCode || '').trim();
            return code.length === 20;
        }

        function searchVoucher() {
            if (!isValidVoucherCode() || vm.isSearching) {
                return;
            }
            var code = vm.voucherSearchCode.trim();
            if (!code.toUpperCase().endsWith('ROLL')) {
                vm.voucherSearchError = $translate.instant('ROLLOVER_INVALID_CODE_SUFFIX');
                return;
            }
            vm.isSearching = true;
            vm.voucherSearchError = null;

            dashboardKarcherActions.getRolloverVouchersBySite(vm.siteId, 0, 1, code).then(
                function (response) {
                    vm.isSearching = false;
                    var vouchers = response.content || [];
                    if (vouchers.length === 0) {
                        vm.voucherSearchError = $translate.instant('ROLLOVER_VOUCHER_NOT_FOUND');
                        return;
                    }
                    // Find exact match
                    var exactMatch = vouchers.find(function(v) {
                        return v.voucherCode && v.voucherCode.toLowerCase() === vm.voucherSearchCode.trim().toLowerCase();
                    });
                    if (!exactMatch) {
                        exactMatch = vouchers[0];
                    }
                    showVoucherDetailDialog(exactMatch);
                },
                function () {
                    vm.isSearching = false;
                    vm.voucherSearchError = $translate.instant('ROLLOVER_VOUCHER_SEARCH_ERROR');
                }
            );
        }

        function showVoucherDetailDialog(voucher) {
            $mdDialog.show({
                controller: VoucherDetailDialogController,
                controllerAs: 'dialog',
                templateUrl: 'app/rollover/rolloverVoucherDetailDialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                escapeToClose: true,
                locals: {
                    voucher: voucher,
                    onPrintVoucher: function(v) {
                        vm.vouchersForPrint = [v];
                        $timeout(function () {
                            window.print();
                            showPrintConfirmDialog(v.voucherCode);
                        }, 100);
                    },
                    onDeactivateVoucher: function(v) {
                        if (v.status !== 'ACTIVE') {
                            return;
                        }
                        dialogsService.showConfirmDialog(
                            "ROLLOVER_DEACTIVATE_TITLE",
                            "ROLLOVER_DEACTIVATE_CONFIRM",
                            "PROCEED"
                        ).then(function () {
                            layoutActions.showLoader();
                            dashboardKarcherActions.deactivateRolloverVoucher(v.id).then(
                                function () {
                                    vm.voucherSearchCode = '';
                                    layoutActions.hideLoader();
                                },
                                function () {
                                    vm.voucherSearchCode = '';
                                    layoutActions.hideLoader();
                                }
                            );
                        });
                    }
                }
            });
        }

        /** @ngInject */
        function VoucherDetailDialogController($mdDialog, voucher, onPrintVoucher, onDeactivateVoucher, $translate, dashboardKarcherActions) {
            var dialog = this;
            dialog.voucher = voucher;
            dialog.isUnlimited = voucher.tokensAmount === -1;
            dialog.remainingWashes = dialog.isUnlimited ? 0 : (voucher.tokensAmount || 0) - (voucher.redeemedTokens || 0);
            dialog.isRedeemed = voucher.status === 'REDEEMED';
            dialog.isExpired = voucher.status === 'EXPIRED';
            dialog.isBlocked = voucher.status === 'BLOCKED';
            dialog.isActive = voucher.status === 'ACTIVE';
            dialog.redeems = [];
            dialog.isLoadingRedeems = true;

            dialog.getStatusLabel = function() {
                return $translate.instant('ROLLOVER_STATUS_' + voucher.status);
            };

            dialog.close = function() {
                $mdDialog.hide();
            };

            dialog.printVoucher = function() {
                $mdDialog.hide();
                onPrintVoucher(voucher);
            };

            dialog.deactivateVoucher = function() {
                $mdDialog.hide();
                onDeactivateVoucher(voucher);
            };

            // Load redemption history
            if (voucher.id) {
                dashboardKarcherActions.getRolloverVoucherRedeems(voucher.id).then(
                    function (data) {
                        dialog.redeems = data || [];
                        dialog.isLoadingRedeems = false;
                    },
                    function () {
                        dialog.redeems = [];
                        dialog.isLoadingRedeems = false;
                    }
                );
            } else {
                dialog.isLoadingRedeems = false;
            }
        }

        function cancelSelection() {
            // Reset all selections
            vm.selectedProgram = null;
            vm.options = [];
            vm.numberOfWashes = 1;
            vm.happyHourEnabled = false;
            vm.happyHour1Start = null;
            vm.happyHour1End = null;
            vm.happyHour2Start = null;
            vm.happyHour2End = null;
            vm.happyHour1StartError = null;
            vm.happyHour1EndError = null;
            vm.happyHour2StartError = null;
            vm.happyHour2EndError = null;
            // Reset sales type to first
            if (vm.salesTypes.length > 0) {
                vm.selectedSalesType = vm.salesTypes[0];
                onSalesTypeChange();
            }
        }

        function incrementWashes(amount) {
            if (vm.selectedSalesType && vm.selectedSalesType.isUnlimitedWashes) {
                return;
            }
            vm.numberOfWashes = (vm.numberOfWashes || 1) + amount;
        }

        function decrementWashes(amount) {
            if (vm.selectedSalesType && vm.selectedSalesType.isUnlimitedWashes) {
                return;
            }
            var newValue = (vm.numberOfWashes || 1) - amount;
            vm.numberOfWashes = newValue < 1 ? 1 : newValue;
        }

        function goToSalesTypes() {
            $state.go('app.rolloverSalesTypes');
        }

        function onSalesTypeChange() {
            if (vm.selectedSalesType && vm.selectedSalesType.isUnlimitedWashes) {
                vm.numberOfWashes = -1;
            } else if (vm.numberOfWashes === -1) {
                vm.numberOfWashes = 1;
            }
        }

        function getListPrice(program) {
            if (!program) {
                return 0;
            }
            if (vm.selectedSalesType && vm.selectedSalesType.isZeroPrice) {
                return 0;
            }
            var useSpecialOfferPrice = vm.selectedSalesType && vm.selectedSalesType.isSpecialOfferPrices;
            if (useSpecialOfferPrice && program.soPrice) {
                return program.soPrice.amount;
            }
            return program.price ? program.price.amount : 0;
        }

        function getProgramPrice() {
            if (!vm.selectedProgram) {
                return 0;
            }
            if (vm.selectedSalesType && vm.selectedSalesType.isZeroPrice) {
                return 0;
            }
            var useSpecialOfferPrice = vm.selectedSalesType && vm.selectedSalesType.isSpecialOfferPrices;
            if (useSpecialOfferPrice && vm.selectedProgram.soPrice) {
                return vm.selectedProgram.soPrice.amount;
            }
            return vm.selectedProgram.price ? vm.selectedProgram.price.amount : 0;
        }

        function onValidFromChange() {
            if (vm.validFrom && vm.validityDays) {
                var newValidTo = new Date(vm.validFrom);
                newValidTo.setDate(newValidTo.getDate() + vm.validityDays);
                vm.validTo = newValidTo;
            }
        }

        function onValidityDaysChange() {
            if (vm.validFrom && vm.validityDays > 0) {
                var newValidTo = new Date(vm.validFrom);
                newValidTo.setDate(newValidTo.getDate() + vm.validityDays);
                vm.validTo = newValidTo;
            }
        }

        function onValidToChange() {
            if (vm.validFrom && vm.validTo) {
                var diffTime = vm.validTo.getTime() - vm.validFrom.getTime();
                var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                vm.validityDays = diffDays > 0 ? diffDays : 1;
            }
        }

        function isValidTimeFormat(time) {
            if (!time) return true; // Empty is valid (not required)
            var regex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
            return regex.test(time);
        }

        function timeToMinutes(time) {
            if (!time) return null;
            var parts = time.split(':');
            return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
        }

        function validateHappyHour1() {
            vm.happyHour1StartError = null;
            vm.happyHour1EndError = null;

            if (vm.happyHour1Start && !isValidTimeFormat(vm.happyHour1Start)) {
                vm.happyHour1StartError = $translate.instant('ROLLOVER_INVALID_TIME_FORMAT');
                return false;
            }

            if (vm.happyHour1End && !isValidTimeFormat(vm.happyHour1End)) {
                vm.happyHour1EndError = $translate.instant('ROLLOVER_INVALID_TIME_FORMAT');
                return false;
            }

            if (vm.happyHour1Start && vm.happyHour1End) {
                var startMinutes = timeToMinutes(vm.happyHour1Start);
                var endMinutes = timeToMinutes(vm.happyHour1End);
                if (endMinutes <= startMinutes) {
                    vm.happyHour1EndError = $translate.instant('ROLLOVER_END_MUST_BE_AFTER_START');
                    return false;
                }
            }

            return true;
        }

        function validateHappyHour2() {
            vm.happyHour2StartError = null;
            vm.happyHour2EndError = null;

            if (vm.happyHour2Start && !isValidTimeFormat(vm.happyHour2Start)) {
                vm.happyHour2StartError = $translate.instant('ROLLOVER_INVALID_TIME_FORMAT');
                return false;
            }

            if (vm.happyHour2End && !isValidTimeFormat(vm.happyHour2End)) {
                vm.happyHour2EndError = $translate.instant('ROLLOVER_INVALID_TIME_FORMAT');
                return false;
            }

            if (vm.happyHour2Start && vm.happyHour2End) {
                var startMinutes = timeToMinutes(vm.happyHour2Start);
                var endMinutes = timeToMinutes(vm.happyHour2End);
                if (endMinutes <= startMinutes) {
                    vm.happyHour2EndError = $translate.instant('ROLLOVER_END_MUST_BE_AFTER_START');
                    return false;
                }
            }

            return true;
        }
    }
})();
